import { Button, Col, Row } from "antd";
import "./Order_Overview.css";
import React, { useContext, useEffect, useState } from "react";
import CheckoutStepFormContext from "../CheckoutStepFormContext";
import Light_Gray_Outline_Btn from "../../../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Increment_decrement_btn_holder from "../../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup, Table } from "react-bootstrap";
import Order_Overview_summery_holder from "./order_Overview_summery_holder/Order_Overview_summery_holder";
import { Link, useNavigate } from "react-router-dom";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Coupons_Modal from "../../../common-components/common_modal/coupons_modal/Coupons_Modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteAllCart, getAllCart } from "../../../../features/cart/cartSlice";
import {
  CouponApplyed,
  createOrder,
  getSingleOrderAddress,
  OrderCalculation,
  OrderResponse,
  PaymentOnline,
} from "../../../../features/order/orderSlice";
import useRazorpay from "react-razorpay";
import { useForm } from "react-hook-form";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";
import Spinner from "react-bootstrap/Spinner";
import { variant_type } from "../../../../utils/common";
import { myAccount } from "../../../../features/my_account/Slice";

const Order_Overview = ({ paymentValue, selectedAddressId }) => {

  const [modalDeleteShow, setModalDeleteShow] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);

  const [data, setData] = useState({});
  const { prev } = useContext(CheckoutStepFormContext);
  const navigate = useNavigate();

  const handleClick = () => {
    setModalShow(true); // Show modal

    setTimeout(() => {
      setModalShow(false); // Close modal after 3s (optional)
      navigate("/"); // Navigate after modal
    }, 3000); // Show for 3 seconds
  };

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  const [CouponData, setCouponData] = React.useState("");

  const [Errors, setErrors] = React.useState(null);
  const [loader, setLoader] = useState(false);

  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const orderCalculation = async (selectedAddressId, currentCurrency) => {
    setLoader(true);

    const data = {
      address_id: selectedAddressId,
      exchange_rate: currentCurrency?.rate,
    };

    if (CouponData) {
      data.coupon_id = CouponData?.id;
    }
    const res = await dispatch(OrderCalculation(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setData(res.payload.data);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors) {
        setErrors(res.payload?.errors);
      }
    }
    await setLoader(false);
  };

  useEffect(() => {
    orderCalculation(selectedAddressId, currentCurrency);
  }, [selectedAddressId, CouponData, currentCurrency]);

  const address = useSelector((state) => state.order.orderAddress);
  useEffect(() => {
    dispatch(getSingleOrderAddress({ id: selectedAddressId }));
  }, [dispatch, selectedAddressId]);

  //order place
  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    dispatch(myAccount());
  }, [dispatch]);

  // const handleRazorpay = async (price) => {
  //   const amountInPaise = Math.round(price * 100);
  //   const options = {
  //     // key: "rzp_test_I05KCFb1v5JJRc",
  //     key: "rzp_test_I05KCFb1v5JJRc",
  //     amount: amountInPaise,
  //     currency: "INR",
  //     name: "Axion Spark",
  //     description: "Test Transaction",
  //     image:
  //       "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

  //     handler: async (res) => {
  //       await setRazorId(res.razorpay_payment_id);
  //       finalFunction(res.razorpay_payment_id);
  //     },
  //     prefill: {
  //       name: "Piyush Garg",
  //       email: "youremail@example.com",
  //       contact: "9999999999",
  //     },
  //     notes: {
  //       address: "Razorpay Corporate Office",
  //     },
  //     theme: {
  //       color: "#052c65",
  //     },
  //   };

  //   const rzpay = new Razorpay(options);
  //   rzpay.open();
  // };

  const handleRazorpay = async (price, data) => {
    const amountInPaise = Math.round(Number(price) * 100);
    console.log(data?.merchant_order_id,"data?.merchant_order_id data?.merchant_order_id");
    
    const options = {
      // key: "rzp_test_I05KCFb1v5JJRc",
      key: "rzp_live_SuHB2juKfrEed3",
      amount: amountInPaise,
      currency: "INR",
      name: "Axion Spark",
      description: "Order Payment",
      order_id: data?.merchant_order_id,


      handler: async function(res) {
        try {
          await PaymentOnlineCreate({
            order_id: data.id,
            razorpay_payment_id: res.razorpay_payment_id,
            // razorpay_order_id: res.razorpay_order_id,
            // razorpay_signature: res.razorpay_signature,
          });
        } catch (err) {
          console.log(err);
        }
      },
      modal: {
        ondismiss: function() {
          setLoader(true);
        },
      },

      prefill: {
        name: user?.name,
        email: user?.email,
        contact: user?.contact_no,
      },

      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new window.Razorpay(options);
    rzpay.open();
  };

  const PaymentOnlineCreate = async (data) => {
    console.log(data,"data data PaymentOnlineCreate");
    
    const res = await dispatch(
      PaymentOnline({
        id: data.order_id,
        payment_id: data.razorpay_payment_id,
      }),

    );

    if (res.meta?.requestStatus === "fulfilled") {
      handleClick();
    }
  };

  const finalFunction = async () => {
   
    setLoader(true);

    const datafinal = {
      exchange_rate_id: currentCurrency?.id,
      exchange_rate: currentCurrency?.rate,
      address_id: selectedAddressId,
      payment_method_id: paymentValue,
      order_summary: data?.order_summary,
      order_Details_summary: data?.order_Details_summary,
    };

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      const redirectUrl = res?.payload?.data?.redirectUrl;

      if (paymentValue === 2) {
        const amount = parseFloat(data?.order_summary?.total_amount);
        const orderData = res?.payload?.data?.order;
        console.log(res,"orderData orderData orderData");
        
        await handleRazorpay(amount, orderData);
      } else {
        handleClick();
      }

      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload) {
        setErrors(res.payload);
      }
    }

    setLoader(false);
  };
  // const finalFunction = async (razorpay) => {
  //   setLoader(true);
  //   const datafinal = {
  //     exchange_rate_id: currentCurrency?.id,
  //     exchange_rate: currentCurrency?.rate,
  //     address_id: selectedAddressId,
  //     payment_method_id: paymentValue,
  //     order_summary: data?.order_summary,
  //     order_Details_summary: data?.order_Details_summary,
  //   };
  //   if (razorpay) {
  //     datafinal.payment_id = razorpay;
  //   }

  //   const res = await dispatch(createOrder(datafinal));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     handleClick();
  //     await dispatch(getAllCart(isSignin));
  //   } else if (res.meta?.requestStatus === "rejected") {
  //     // if (res.payload?.errors?.email) {
  //     //     setError("email", {
  //     //       type: "manual",
  //     //       message: res.payload?.errors?.email,
  //     //     });
  //     //   }
  //   }
  //   setLoader(false);
  // };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (d) => {
    d.amount = data?.order_summary?.total_selling_price;
    const res = await dispatch(CouponApplyed(d));
    clearErrors();
    if (res?.payload?.data) {
      setCouponData(res?.payload?.data);
      setValue("code", d?.code);
    }
    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload?.errors,
      });
    }
    setShowCouponModal(false);
  };

  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignin, product_id, varient_id }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
      await orderCalculation(selectedAddressId);
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };

  return (
    <>
      <div className={"Cart_Products_card Order_Overview"}>
        <div className="row">
          <div className="col-md-7">
            <div className="table-responsive">
              <Table>
                <tbody>
                  {allcartData?.data?.map((val) => (
                    <tr>
                      <td>
                        <div className="row">
                          <div className="col-md-4 col-12">
                            <div className="img_holder">
                              <img
                                className="Product_img"
                                src={
                                  process.env.REACT_APP_IMG_URL +
                                  val.Product?.image
                                }
                                alt={"Product_img"}
                              />
                            </div>
                          </div>
                          <div className="col-md-8 col-12">
                            <div className="info_text_holder">
                              <div>
                                <h4>{val.Product?.name}</h4>
                                <p className="sale_price">
                                  <strong>Sale Price:</strong> {symbol}
                                  {Number(
                                    Number(
                                      val.Product_Variant?.price ||
                                        val.Double_Variant?.price ||
                                        val.Triple_Variant?.price,
                                    ) * rate,
                                  ).toFixed(2)}{" "}
                                  <span>
                                    <strong>MRP:</strong> {symbol}
                                    {Number(
                                      Number(
                                        val.Product_Variant?.mrp ||
                                          val.Double_Variant?.mrp ||
                                          val.Triple_Variant?.mrp,
                                      ) * rate,
                                    ).toFixed(2)}{" "}
                                  </span>
                                </p>
                                <h6>
                                  {val?.Product?.variant_type_id ===
                                    variant_type.Single && (
                                    <>
                                      <strong>
                                        {" "}
                                        {val?.Product?.variant_name ||
                                          "Variant"}{" "}
                                        :
                                      </strong>{" "}
                                      {val?.Product_Variant?.Metal?.name}
                                    </>
                                  )}

                                  {val?.Product?.variant_type_id ===
                                    variant_type.Double && (
                                    <>
                                      <strong>
                                        {" "}
                                        {val?.Product?.variant_name ||
                                          "Variant"}{" "}
                                        :
                                      </strong>{" "}
                                      {
                                        val?.Double_Variant?.Product_Variant
                                          ?.Metal?.name
                                      }
                                      , <strong>Size:</strong>{" "}
                                      {val?.Double_Variant?.Size?.name}{" "}
                                    </>
                                  )}

                                  {val?.Product?.variant_type_id ===
                                    variant_type.Triple && (
                                    <>
                                      <strong>Size :</strong>{" "}
                                      {
                                        val?.Triple_Variant?.Double_Variant
                                          ?.Product_Variant?.Metal?.name
                                      }
                                      , <strong>Size:</strong>{" "}
                                      {
                                        val?.Triple_Variant?.Double_Variant
                                          ?.Size?.name
                                      }
                                      , <strong>Diamond:</strong>{" "}
                                      {val?.Triple_Variant?.Diamond?.name}
                                    </>
                                  )}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className="Quantity_tr_holder">
                          <div className="price_holder">
                            <p className="mb-0">
                              {symbol}{" "}
                              {Number(
                                Number(
                                  val.Product_Variant?.price ||
                                    val.Double_Variant?.price ||
                                    val.Triple_Variant?.price,
                                ) * rate,
                              ).toFixed(2) * Number(val.quantity)}
                              <span>
                                {symbol}{" "}
                                {Number(
                                  Number(
                                    val.Product_Variant?.mrp ||
                                      val.Double_Variant?.mrp ||
                                      val.Triple_Variant?.mrp,
                                  ) * rate,
                                ).toFixed(2) * Number(val.quantity)}{" "}
                              </span>
                            </p>{" "}
                            <br />
                          </div>
                          <FontAwesomeIcon
                            className="trash_icon ms-3"
                            icon={faTrashCan}
                            onClick={() =>
                              deleteCart(
                                val?.id,
                                val?.product_id,
                                val?.variant_id,
                              )
                            }
                          />
                        </div>

                        <div className="Quantity_tr_holder">
                          <div className="price_holder">
                            <p className="mb-0">Qty: {val?.quantity} </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="col-md-5">
            <Order_Overview_summery_holder
              data={data}
              address={address}
              paymentValue={paymentValue}
            />
            <div style={{ color: "red" }}>{Errors}</div>
            {errors.code && (
              <div style={{ color: "red" }}>{errors?.code?.message}</div>
            )}
            <div className="Rewards_text_holder">
              <h4>Offers and Rewards</h4>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <InputGroup className="mb-3">
                  <InputGroup.Text
                    className="tags_icon_holder"
                    id="basic-addon2"
                  >
                    {" "}
                    <FontAwesomeIcon className="tags_icon" icon={faTags} />
                  </InputGroup.Text>

                  <Form.Control
                    className="mb-0"
                    placeholder="Enter Coupon Code"
                    {...register("code", {
                      required: "Coupon code is required",
                    })}
                    readOnly={!!CouponData}
                  />

                  {CouponData ? (
                    // If coupon code exists, View acts as submit
                    <InputGroup.Text
                      as="button"
                      type="submit"
                      className="view_grp"
                      id="basic-addon2"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setCouponData("");
                        setValue("code", "");
                      }}
                    >
                      Remove
                    </InputGroup.Text>
                  ) : (
                    // If no code, open modal
                    <InputGroup.Text
                      className="view_grp"
                      id="basic-addon2"
                      onClick={() => setShowCouponModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      View
                    </InputGroup.Text>
                  )}
                  {/* <InputGroup.Text
                  className="view_grp"
                  id="basic-addon2"
                  onClick={() => {
                    setShowCouponModal(true);
                  }}
                >
                  View
                </InputGroup.Text> */}
                </InputGroup>
              </Form>
            </div>

            {loader ? (
              <>
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </>
            ) : (
              <>
                <div className="btn_holder d-flex justify-content-center">
                  <Green_Outline_Btn btnText={"Back"} onClick={prev} />
                  {allcartData?.data?.length > 0 ? (
                    <Green_Outline_Btn
                      btnText={"Place Order"}
                      // onClick={() =>
                      //   paymentValue !== 2
                      //     ? finalFunction()
                      //     : handleRazorpay(data?.order_summary?.total_amount)
                      // }
                      onClick={() => finalFunction()}
                    />
                  ) : (
                    <Green_Outline_Btn
                      btnText={"Continue Shopping"}
                      onClick={() => navigate("/shops")}
                    />
                    // <Link to="/shops" className="btn btn-outline-success">
                    //   Continue Shopping
                    // </Link>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Your Order Has Been Placed Successfully!"
      />

      <Coupons_Modal
        setValue={setValue}
        setCouponData={setCouponData}
        onSubmit={onSubmit}
        data={data}
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      />

      <Delete_Modal
        show={modalDeleteShow}
        onHide={() => setModalDeleteShow(false)}
        successText="Order Deleted Sucessfuly"
      />
    </>
  );
};
export default Order_Overview;
